import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ProgramReportUIHelpers";

const ProgramReportUIContext = createContext();

export function useProgramReportUIContext() {
  return useContext(ProgramReportUIContext);
}

export const ProgramReportUIConsumer = ProgramReportUIContext.Consumer;

export function ProgramReportUIProvider({ programReportUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initProgramReport = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initProgramReport
  };

  return (
    <ProgramReportUIContext.Provider value={value}>
      {children}
    </ProgramReportUIContext.Provider>
  );
}
